import { render, staticRenderFns } from "./SettingsContentTemplate.vue?vue&type=template&id=1372a8a4&scoped=true&"
import script from "./SettingsContentTemplate.vue?vue&type=script&lang=js&"
export * from "./SettingsContentTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SettingsContentTemplate.vue?vue&type=style&index=0&id=1372a8a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1372a8a4",
  null
  
)

/* custom blocks */
import block0 from "./SettingsContentTemplate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports